import {
  Directive, EventEmitter,
  HostListener, Input, Output
} from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Directive({
  selector: "[appCopyToClipboard]"
})
export class CopyToClipboardDirective {
  @Input("appCopyToClipboard")
  public payload: string;

  @Input("context")
  public context: string;

  @Output("copied")
  public copied: EventEmitter<string> = new EventEmitter<string>();

  constructor(private toastr: ToastrService) { }

  @HostListener("click", ["$event"])
  public onClick(event: MouseEvent): void {
    event.preventDefault();
    if (!this.payload) {
      return;
    }

    const listener = (e: ClipboardEvent) => {
      const clipboard = e.clipboardData || (window as any)["clipboardData"];
      clipboard.setData("text", this.payload.toString());
      e.preventDefault();
      this.copied.emit(this.payload);
      this.toastr.success("Copied to clipboard!", "Success");
    };

    document.addEventListener("copy", listener, false);
    document.execCommand("copy");
    document.removeEventListener("copy", listener, false);
  }
}